<template>
<div> 
  <b-button v-b-tooltip title="Fermer" @click="closeSideBar()" variant="light" class="closeButton">
    <img src="../../../assets/logos/close_black.png" alt="close" class="img-fluid"/> 
  </b-button>
  <h5 id="sideBar_spIdentifier">
  Point d'enquête n° {{ currentSurveyPoint.spIdentifier }} 
  - <a v-bind:href="currentSurveyPoint.dbPediaLink" target="_blank">{{ currentSurveyPoint.placeName }} </a>
</h5>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SurveyPointSideBar',
  data() {
    return {
      currentSurveyPoint: null,
    }
  },
  computed: {
    ...mapGetters({
      currentInventoryEntry: 'getCurrentInventoryEntry',
      mode: 'getMode'
    })
  },
  watch: {
    currentInventoryEntry() {
      this.currentInventoryEntry
      this.currentSurveyPoint = this.$store.getters.getSurveyPoint(this.currentInventoryEntry.spIdentifier)
    }
  },
  created() {
    this.currentSurveyPoint = this.$store.getters.getSurveyPoint(this.currentInventoryEntry.spIdentifier)
  },
  methods: {
    // Ferme le bandeau latéral
    closeSideBar: function() { 
      this.$store.dispatch('closeSideBar', this.mode) 
    }
  }
}
</script>
<style>
.closeButton {
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/commons/sideBarViewer/SurveyPointSideBar.vue